module.exports = __webpack_public_path__ + "static/media/image5.ece629b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ClickImage/images/image5.jpg
// module id = 39
// module chunks = 0